<template>
	<div>
		<section-header />
		<div class="sidebar-page-container">
		      	<div class="auto-container">
		          	<div class="row clearfix">
		
		                  <!--Content Side / Services Single-->
		                  <div class="content-side pull-right col-lg-8 col-md-8 col-sm-12 col-xs-12">
		                  	<div class="services-single">
		                      	<div class="inner-box">
		
		                              <!--Upper Box-->
		                              <div class="upper-box">
		                                  <div class="row clearfix">
		                                      <div class="column col-md-6 col-sm-6 col-xs-12">
		                                          <div class="upper-text">We work closely with Employers across the industry sectors to ensures their internal Human Resources of systems and processes align to uts their business on requirements of our “Best Practices” strategies thats all HR processes ut are ut directly aligned legislative obligattions works closely with employers across all industry sectors to ensure their internal human Resource systems & processes.</div>
		                                          <ul class="list-style-three">
		                                              <li>Smart way to work and get good results</li>
		                                              <li>To create value and make a diffrence</li>
		                                              <li>Be a great place to work people inspired</li>
		                                              <li>Inspire moments of optimism & Happiness</li>
		                                          </ul>
		                                      </div>
		                                      <div class="column col-md-6 col-sm-6 col-xs-12">
		                                          <div class="image">
		                                              <img src="images/resource/services-7.jpg" alt="" />
		                                          </div>
		                                      </div>
		                                  </div>
		                              </div>
		                              <!--Upper Box-->
		
		                              <!--Services Block Seven-->
		                              <div class="row clearfix">
		
		                              	<!--Services Block Seven-->
		                              	<div class="services-block-seven col-md-6 col-sm-12 col-xs-12">
		                                  	<div class="inner">
		                                      	<div class="icon-box"><span class="icon flaticon-honeycomb"></span></div>
		                                          <h3><a href="#">Why We Consulting</a></h3>
		                                          <div class="text">We have over 25 years experience in Consulting Service.</div>
		                                      </div>
		                                  </div>
		
		                                  <!--Services Block Seven-->
		                              	<div class="services-block-seven col-md-6 col-sm-12 col-xs-12">
		                                  	<div class="inner">
		                                      	<div class="icon-box"><span class="icon flaticon-international-search-symbol"></span></div>
		                                          <h3><a href="#">Pay for Success</a></h3>
		                                          <div class="text">We present you the various topics of business consultations</div>
		                                      </div>
		                                  </div>
		
		                                  <!--Services Block Seven-->
		                              	<div class="services-block-seven col-md-6 col-sm-12 col-xs-12">
		                                  	<div class="inner">
		                                      	<div class="icon-box"><span class="icon flaticon-phone-call-1"></span></div>
		                                          <h3><a href="#">Tailor-Made Solutions</a></h3>
		                                          <div class="text">Always work with premium community development impact investors.</div>
		                                      </div>
		                                  </div>
		
		                                  <!--Services Block Seven-->
		                              	<div class="services-block-seven col-md-6 col-sm-12 col-xs-12">
		                                  	<div class="inner">
		                                      	<div class="icon-box"><span class="icon flaticon-businessman"></span></div>
		                                          <h3><a href="#">Segregated Accounts</a></h3>
		                                          <div class="text">Raising business development, and the involvement of partners.</div>
		                                      </div>
		                                  </div>
		
		                              </div>
		
		                              <h4>Profit Improvement</h4>
		                              <div class="row clearfix">
		                              	<div class="column col-md-7 col-sm-7 col-xs-12">
		                              		<div class="text">We assist organizations that are underperforming or seeking us profit as well as those in transition those or in the midst get our significant whatever the situation.</div>
		                                      <ul class="list-style-five">
		                                      	<li>Cost-reduction opportunity analysis</li>
		                                          <li>Revenue and margin improvement strategies</li>
		                                          <li>Lean, Six Sigma and continuous improvement</li>
		                                      </ul>
		                                  </div>
		                                  <div class="column text-center col-md-5 col-sm-5 col-xs-12">
		                                  	<!--Graph-->
		                                      <div class="graph-outer clearfix">
		                                      	<div class="donut-graph">
		                                          	<canvas id="profit-improvement-graph" style="width:100%;"></canvas>
		                                          </div>
		                                      </div>
		                                  </div>
		                              </div>
		                              <br><br>
		                              <ul class="accordion-box style-five">
		                                  <!--Block-->
		                                  <li class="accordion block">
		                                      <div class="acc-btn"><div class="icon-outer"><span class="icon icon-plus flaticon-plus"></span> <span class="icon flaticon-minus flaticon-line"></span></div>B-COM have a unique way of working </div>
		                                      <div class="acc-content">
		                                          <div class="content">
		                                              <div class="text">
		                                                  <p>Get the best guidance. We serve a clients at every level of their organization we can be most useful, whether as a trusted advisor to top trusted our management coach for fronts line employees.</p>
		                                              </div>
		                                          </div>
		                                      </div>
		                                  </li>
		
		                                  <!--Block-->
		                                  <li class="accordion block">
		                                      <div class="acc-btn active"><div class="icon-outer"><span class="icon icon-plus flaticon-plus"></span> <span class="icon flaticon-minus flaticon-line"></span></div>We bring together the best people to the world</div>
		                                      <div class="acc-content current">
		                                          <div class="content">
		                                              <div class="text">
		                                                  <p>Get the best guidance. We serve a clients at every level of their organization we can be most useful, whether as a trusted advisor to top trusted our management coach for fronts line employees.</p>
		                                              </div>
		                                          </div>
		                                      </div>
		                                  </li>
		
		                                  <!--Block-->
		                                  <li class="accordion block">
		                                      <div class="acc-btn"><div class="icon-outer"><span class="icon icon-plus flaticon-plus"></span> <span class="icon flaticon-minus flaticon-line"></span></div>Submit your sponsorship request easy way</div>
		                                      <div class="acc-content">
		                                          <div class="content">
		                                              <div class="text">
		                                                  <p>Get the best guidance. We serve a clients at every level of their organization we can be most useful, whether as a trusted advisor to top trusted our management coach for fronts line employees.</p>
		                                              </div>
		                                          </div>
		                                      </div>
		                                  </li>
		
		                                  <!--Block-->
		                                  <li class="accordion block">
		                                      <div class="acc-btn"><div class="icon-outer"><span class="icon icon-plus flaticon-plus"></span> <span class="icon flaticon-minus flaticon-line"></span></div>Revenue and margin improvement strategies</div>
		                                      <div class="acc-content">
		                                          <div class="content">
		                                              <div class="text">
		                                                  <p>Get the best guidance. We serve a clients at every level of their organization we can be most useful, whether as a trusted advisor to top trusted our management coach for fronts line employees.</p>
		                                              </div>
		                                          </div>
		                                      </div>
		                                  </li>
		
		                              </ul>
		                              <br><br>
		                              <h4>Strategy Development</h4>
		                              <div class="text">How all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete accounts of the system, and expounds the actual teachings of the great explorer seds of the truth master builder of human happiness. No one rejects, dislikes, or avoids pleasure sed itself, because it is pleasure, but  pleasure rationally encounter consequences that are extremely.</div>
		                              <br><br>
		                              <!--Graph-->
		                              <div class="graph-outer clearfix">
		                                  <div class="double-bar-graph">
		                                      <canvas id="strategy-graph" style="width:100%;"></canvas>
		                                  </div>
		                              </div>
		                          </div>
		                      </div>
		                  </div>
		
		                  <!--Sidebar-->
		                  <div class="sidebar-side pull-left col-lg-4 col-md-4 col-sm-12 col-xs-12">
		                      <aside class="sidebar">
		
		                          <!--Services Category-->
		                          <div class="sidebar-widget services-category">
		                          	<ul class="services-list">
		                              	<li><a href="#"><span class="icon flaticon-startup"></span>Business Transformation</a></li>
		                                  <li class="active"><a href="#"><span class="icon flaticon-analytics-1"></span>Turnaround & Restructuring</a></li>
		                                  <li><a href="#"><span class="icon flaticon-structure"></span>Bonds and Commodities</a></li>
		                                  <li><a href="#"><span class="icon flaticon-donation"></span>Valuation & Finance Advisory</a></li>
		                                  <li><a href="#"><span class="icon flaticon-note-2"></span>Audit and Assurance</a></li>
		                                  <li><a href="#"><span class="icon flaticon-business-3"></span>Trades and Stocks</a></li>
		                              </ul>
		                          </div>
		
		                          <!--Brouchures Category-->
		                          <div class="sidebar-widget brouchure-widget">
		                          	<div class="inner-box">
		                              	<h2>Download Brochures</h2>
		                                  <div class="text">Here you can view our financial prospectus brochures of year 2016.</div>
		                                  <a class="download-btn" href="#"><span class="icon flaticon-pdf"></span> Download.PDF</a>
		                                  <div class="large-icon"><span class="icon flaticon-pdf"></span></div>
		                              </div>
		                          </div>
		
		                          <!--Contact Category-->
		                          <div class="sidebar-widget contact-widget">
		                          	<div class="inner-box">
		                              	<h2>Our team ready to help you, please contact!</h2>
		                                  <div class="text">We recently helped a small business grow from break-even to over $1m profit in less than 2 years.</div>
		                                  <a href="#" class="contact-btn"><span class="icon flaticon-telephone"></span>Contact Us</a>
		                                  <div class="large-icon"><span class="flaticon-global-networking"></span></div>
		                              </div>
		                          </div>
		
		  					</aside>
		                  </div>
		
		              </div>
		          </div>
				  <script type="application/javascript" defer src="js/script.js"></script>
		      </div>
		
	</div>
</template>

<script>
import SectionHeader from '@/components/SectionHeader.vue';

export default {
  name: 'ServicesManagement',
  components: {
    SectionHeader
  },
  data() {
    return {
      content: ''
    };
  },
  mounted() {

  }
};
</script>